import { takeLatest } from 'redux-saga/effects';
import {
    GetEmployeeBasicSaga,
    AddEmployeeBasicSaga,
    UpdateEmployeeBasicSaga,
    AddEmployeeBankSaga,
    UpdateEmployeeBankSaga,
    DeleteEmployeeBankSaga,
    GetEmployeeBankSaga,
    GetEmployeeFamilySaga,
    AddEmployeeFamilySaga,
    DeleteEmployeeFamilySaga,
    UpdateEmployeeFamilySaga,
    GetEmployeeEducationSaga,
    AddEmployeeEducationSaga,
    UpdateEmployeeEducationSaga,
    DeleteEmployeeEducationSaga,
    GetEmployeeWorkExperienceSaga,
    AddEmployeeWorkExperienceSaga,
    UpdateEmployeeWorkExperienceSaga,
    DeleteEmployeeWorkExperienceSaga,
    GetEmployeePersonalSaga,
    UpdateEmployeePersonalSaga,
    AddEmployeePersonalSaga,
    DeleteEmployeePersonalSaga,
    GetEmployeeOtherPersonalSaga,
    UpdateEmployeeOtherPersonalSaga,
    GetEmployeeWorkDetailSaga,
    UpdateEmployeeWorkDetailSaga,
    AddEmployeeWorkDetailSaga,
    GetEmployeesSaga,
    GetEmployeePayrollDetailsSaga,
    UpdateEmployeePayrollDetailsSaga,
    GetAtsEmployeesSaga,
    UpdateEmployeeAddressSaga,
    GetEmployeeAddressSaga,
    GetEmployeesFaceSaga,
    GetEmployeePayrollProfileDetailSaga,
    UpdateEmployeePayrollProfileDetailSaga,
    GetVisitorsSaga,
    AddVisitorsSaga,
    GetVisitorReasonsSaga,
    UpdateVisitorSaga,
    GetVisitorDataSaga,
    GetVisitorManagementReason,
    AddVisitorManagementReason,
    UpdateVisitorManagementReason,
    DeleteVisitorManagementReason,
    GetVisitorManagementRegion,
    AddVisitorManagementRegion,
    UpdateVisitorManagementRegion,
    DeleteVisitorManagementRegion,
    UpdateBulkVisitorSaga,
    GetVMExtraSettingConfig,
    UpdateVMExtraSettingConfig,
    GetManageGoal,
    AddManageGoal,
    UpdateManageGoal,
    DeleteManageGoal,
    GetPmsFeedback,
    AddPmsFeedback,
    UpdatePmsFeedback,
    DeletePmsFeedback,
    GetGoalType,
    AddGoalType,
    UpdateGoalType,
    DeleteGoalType,
    GetGoalSubtype,
    AddGoalSubtype,
    UpdateGoalSubtype,
    DeleteGoalSubtype,
    GetECMSExitReason,
    AddECMSExitReason,
    UpdateECMSExitReason,
    DeleteECMSExitReason,
    GetECMSClearanceType,
    AddECMSClearanceType,
    UpdateECMSClearanceType,
    DeleteECMSClearanceType,
    GetEmployeeClearance,
    AddEmployeeClearance,
    UpdateEmployeeClearance,
    DeleteEmployeeClearance,
    GetAdminExitEmployee,
    GetPerformanceLog,
    AddPerformanceLog,
    UpdatePerformanceLog,
    DeletePerformanceLog,
    GetMyGoal,
    GetEmployeeTokenConfig,
    AddEmployeeTokenConfig,
    UpdateEmployeeTokenConfig,
    DeleteEmployeeTokenConfig,
    GetCanteenManagementRegion,
    AddCanteenManagementRegion,
    UpdateCanteenManagementRegion,
    DeleteCanteenManagementRegion,
    GetVMOrgTypeSaga,
    UpdateVMOrgTypeSaga,
    GetVMMultipleOrgConfigurationSaga,
    UpsertVMMultipleOrgConfigurationSaga,
    DeleteVMMultipleOrgConfigurationSaga,
    GetVMPreRegistrationVisitorSaga,
    UpsertVMPreRegistrationVisitorSaga,
    DeleteVMPreRegistrationVisitorSaga,
    GetEACUser,
    AddEACUser,
    UpdateEACUsers
} from './EmployeeSaga';


import * as ActionTypes from './ActionTypes';

export default function* EmployeeWatcher() {
    yield takeLatest(ActionTypes.EMPLOYEES_GET_REQUEST, GetEmployeesSaga);
    yield takeLatest(ActionTypes.EMPLOYEES_FACE_GET_REQUEST, GetEmployeesFaceSaga);
    yield takeLatest(ActionTypes.ATS_EMPLOYEES_GET_REQUEST, GetAtsEmployeesSaga);
    yield takeLatest(ActionTypes.GET_EMPLOYEE_BASIC_REQUEST, GetEmployeeBasicSaga);
    yield takeLatest(ActionTypes.ADD_EMPLOYEE_BASIC_REQUEST, AddEmployeeBasicSaga);
    yield takeLatest(ActionTypes.UPDATE_EMPLOYEE_BASIC_REQUEST, UpdateEmployeeBasicSaga);
    yield takeLatest(ActionTypes.GET_EMPLOYEE_BANK_REQUEST, GetEmployeeBankSaga);
    yield takeLatest(ActionTypes.ADD_EMPLOYEE_BANK_REQUEST, AddEmployeeBankSaga);
    yield takeLatest(ActionTypes.UPDATE_EMPLOYEE_BANK_REQUEST, UpdateEmployeeBankSaga);
    yield takeLatest(ActionTypes.DELETE_EMPLOYEE_BANK_REQUEST, DeleteEmployeeBankSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_FAMILY_GET_REQUEST, GetEmployeeFamilySaga);
    yield takeLatest(ActionTypes.EMPLOYEE_FAMILY_ADD_REQUEST, AddEmployeeFamilySaga);
    yield takeLatest(ActionTypes.EMPLOYEE_FAMILY_UPDATE_REQUEST, UpdateEmployeeFamilySaga);
    yield takeLatest(ActionTypes.EMPLOYEE_FAMILY_DELETE_REQUEST, DeleteEmployeeFamilySaga);
    yield takeLatest(ActionTypes.EMPLOYEE_EDUCATION_GET_REQUEST, GetEmployeeEducationSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_EDUCATION_ADD_REQUEST, AddEmployeeEducationSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_EDUCATION_UPDATE_REQUEST, UpdateEmployeeEducationSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_EDUCATION_DELETE_REQUEST, DeleteEmployeeEducationSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_WORK_EXPERIENCE_GET_REQUEST, GetEmployeeWorkExperienceSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_WORK_EXPERIENCE_ADD_REQUEST, AddEmployeeWorkExperienceSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_WORK_EXPERIENCE_UPDATE_REQUEST, UpdateEmployeeWorkExperienceSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_WORK_EXPERIENCE_DELETE_REQUEST, DeleteEmployeeWorkExperienceSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_PERSONAL_GET_REQUEST, GetEmployeePersonalSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_PERSONAL_ADD_REQUEST, AddEmployeePersonalSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_PERSONAL_UPDATE_REQUEST, UpdateEmployeePersonalSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_PERSONAL_DELETE_REQUEST, DeleteEmployeePersonalSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_OTHER_PERSONAL_GET_REQUEST, GetEmployeeOtherPersonalSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_OTHER_PERSONAL_UPDATE_REQUEST, UpdateEmployeeOtherPersonalSaga);

    yield takeLatest(ActionTypes.EMPLOYEE_ADDRESS_GET_REQUEST, GetEmployeeAddressSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_ADDRESS_UPDATE_REQUEST, UpdateEmployeeAddressSaga);
    
    yield takeLatest(ActionTypes.EMPLOYEE_WORK_DETAIL_GET_REQUEST, GetEmployeeWorkDetailSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_WORK_DETAIL_ADD_REQUEST, AddEmployeeWorkDetailSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_WORK_DETAIL_UPDATE_REQUEST, UpdateEmployeeWorkDetailSaga);
    yield takeLatest(ActionTypes.GET_EMPLOYEE_PAYROLL_DETAILS_REQUEST, GetEmployeePayrollDetailsSaga);
    yield takeLatest(ActionTypes.UPDATE_EMPLOYEE_PAYROLL_DETAILS_REQUEST, UpdateEmployeePayrollDetailsSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_PAYROLL_PROFILE_DETAIL_GET_REQUEST, GetEmployeePayrollProfileDetailSaga);
    yield takeLatest(ActionTypes.EMPLOYEE_PAYROLL_PROFILE_DETAIL_UPDATE_REQUEST, UpdateEmployeePayrollProfileDetailSaga);

    yield takeLatest(ActionTypes.VISITORS_GET_REQUEST, GetVisitorsSaga);
    yield takeLatest(ActionTypes.VISITORS_DATA_GET_REQUEST, GetVisitorDataSaga);
    yield takeLatest(ActionTypes.ADD_VISITORS_REQUEST, AddVisitorsSaga);
    yield takeLatest(ActionTypes.UPDATE_VISITORS_REQUEST, UpdateVisitorSaga);
    yield takeLatest(ActionTypes.UPDATE_BULK_VISITORS_REQUEST, UpdateBulkVisitorSaga);
    yield takeLatest(ActionTypes.GET_VISITORS_REASON_REQUEST, GetVisitorReasonsSaga);
    yield takeLatest(ActionTypes.VM_EXTRA_SETTING_GET_REQUEST, GetVMExtraSettingConfig);
    yield takeLatest(ActionTypes.VM_EXTRA_SETTING_UPDATE_REQUEST , UpdateVMExtraSettingConfig);
    
    yield takeLatest(ActionTypes.VISITOR_MANAGEMENT_REASON_GET_REQUEST, GetVisitorManagementReason);
    yield takeLatest(ActionTypes.VISITOR_MANAGEMENT_REASON_ADD_REQUEST, AddVisitorManagementReason);
    yield takeLatest(ActionTypes.VISITOR_MANAGEMENT_REASON_UPDATE_REQUEST, UpdateVisitorManagementReason);
    yield takeLatest(ActionTypes.VISITOR_MANAGEMENT_REASON_DELETE_REQUEST, DeleteVisitorManagementReason);

    // Visitor Management Region
    yield takeLatest(ActionTypes.VISITOR_MANAGEMENT_REGION_GET_REQUEST, GetVisitorManagementRegion);
    yield takeLatest(ActionTypes.VISITOR_MANAGEMENT_REGION_ADD_REQUEST, AddVisitorManagementRegion);
    yield takeLatest(ActionTypes.VISITOR_MANAGEMENT_REGION_UPDATE_REQUEST, UpdateVisitorManagementRegion);
    yield takeLatest(ActionTypes.VISITOR_MANAGEMENT_REGION_DELETE_REQUEST, DeleteVisitorManagementRegion);
    // PMS
    yield takeLatest(ActionTypes.MY_GOAL_GET_REQUEST, GetMyGoal);
    yield takeLatest(ActionTypes.MANAGE_GOAL_GET_REQUEST, GetManageGoal);
    yield takeLatest(ActionTypes.MANAGE_GOAL_ADD_REQUEST, AddManageGoal);
    yield takeLatest(ActionTypes.MANAGE_GOAL_UPDATE_REQUEST, UpdateManageGoal);
    yield takeLatest(ActionTypes.MANAGE_GOAL_DELETE_REQUEST, DeleteManageGoal);

    yield takeLatest(ActionTypes.PMS_FEEDBACK_GET_REQUEST, GetPmsFeedback);
    yield takeLatest(ActionTypes.PMS_FEEDBACK_ADD_REQUEST, AddPmsFeedback);
    yield takeLatest(ActionTypes.PMS_FEEDBACK_UPDATE_REQUEST, UpdatePmsFeedback);
    yield takeLatest(ActionTypes.PMS_FEEDBACK_DELETE_REQUEST, DeletePmsFeedback);
    yield takeLatest(ActionTypes.GET_ECMS_EXIT_REASON_REQUEST, GetECMSExitReason);
    yield takeLatest(ActionTypes.ADD_ECMS_EXIT_REASON_REQUEST, AddECMSExitReason);
    yield takeLatest(ActionTypes.UPDATE_ECMS_EXIT_REASON_REQUEST, UpdateECMSExitReason);
    yield takeLatest(ActionTypes.DELETE_ECMS_EXIT_REASON_REQUEST, DeleteECMSExitReason);
    
    yield takeLatest(ActionTypes.GET_ECMS_CLEARANCE_TYPE_REQUEST, GetECMSClearanceType);
    yield takeLatest(ActionTypes.ADD_ECMS_CLEARANCE_TYPE_REQUEST, AddECMSClearanceType);
    yield takeLatest(ActionTypes.UPDATE_ECMS_CLEARANCE_TYPE_REQUEST, UpdateECMSClearanceType);
    yield takeLatest(ActionTypes.DELETE_ECMS_CLEARANCE_TYPE_REQUEST, DeleteECMSClearanceType);

    yield takeLatest(ActionTypes.EMPLOYEE_CLEARANCE_GET_REQUEST, GetEmployeeClearance);
    yield takeLatest(ActionTypes.EMPLOYEE_CLEARANCE_ADD_REQUEST, AddEmployeeClearance);
    yield takeLatest(ActionTypes.EMPLOYEE_CLEARANCE_UPDATE_REQUEST, UpdateEmployeeClearance);
    yield takeLatest(ActionTypes.EMPLOYEE_CLEARANCE_DELETE_REQUEST, DeleteEmployeeClearance);

    yield takeLatest(ActionTypes.ECMS_ADMIN_EXIT_EMPLOYEE_GET_REQUEST, GetAdminExitEmployee);

    yield takeLatest(ActionTypes.GOAL_TYPE_GET_REQUEST, GetGoalType);
    yield takeLatest(ActionTypes.GOAL_TYPE_ADD_REQUEST, AddGoalType);
    yield takeLatest(ActionTypes.GOAL_TYPE_UPDATE_REQUEST, UpdateGoalType);
    yield takeLatest(ActionTypes.GOAL_TYPE_DELETE_REQUEST, DeleteGoalType);
    yield takeLatest(ActionTypes.GOAL_SUBTYPE_GET_REQUEST, GetGoalSubtype);
    yield takeLatest(ActionTypes.GOAL_SUBTYPE_ADD_REQUEST, AddGoalSubtype);
    yield takeLatest(ActionTypes.GOAL_SUBTYPE_UPDATE_REQUEST, UpdateGoalSubtype);
    yield takeLatest(ActionTypes.GOAL_SUBTYPE_DELETE_REQUEST, DeleteGoalSubtype);

    yield takeLatest(ActionTypes.PERFORMANCE_LOG_GET_REQUEST, GetPerformanceLog);
    yield takeLatest(ActionTypes.PERFORMANCE_LOG_ADD_REQUEST, AddPerformanceLog);
    yield takeLatest(ActionTypes.PERFORMANCE_LOG_UPDATE_REQUEST, UpdatePerformanceLog);
    yield takeLatest(ActionTypes.PERFORMANCE_LOG_DELETE_REQUEST, DeletePerformanceLog);

    yield takeLatest(ActionTypes.EMPLOYEE_CANTEEN_TOKEN_GET_REQUEST, GetEmployeeTokenConfig);
    yield takeLatest(ActionTypes.EMPLOYEE_CANTEEN_TOKEN_ADD_REQUEST, AddEmployeeTokenConfig);
    yield takeLatest(ActionTypes.EMPLOYEE_CANTEEN_TOKEN_UPDATE_REQUEST, UpdateEmployeeTokenConfig);
    yield takeLatest(ActionTypes.EMPLOYEE_CANTEEN_TOKEN_DELETE_REQUEST, DeleteEmployeeTokenConfig);

    // Visitor Management Region
    yield takeLatest(ActionTypes.CANTEEN_MANAGEMENT_REGION_GET_REQUEST, GetCanteenManagementRegion);
    yield takeLatest(ActionTypes.CANTEEN_MANAGEMENT_REGION_ADD_REQUEST, AddCanteenManagementRegion);
    yield takeLatest(ActionTypes.CANTEEN_MANAGEMENT_REGION_UPDATE_REQUEST, UpdateCanteenManagementRegion);
    yield takeLatest(ActionTypes.CANTEEN_MANAGEMENT_REGION_DELETE_REQUEST, DeleteCanteenManagementRegion);

    // VM Org Type
    yield takeLatest(ActionTypes.VM_ORG_TYPE_GET_REQUEST, GetVMOrgTypeSaga);
    yield takeLatest(ActionTypes.VM_ORG_TYPE_UPDATE_REQUEST, UpdateVMOrgTypeSaga);

    // VM Multiple Org Configuration
    yield takeLatest(ActionTypes.VM_MULTIPLE_ORG_GET_REQUEST, GetVMMultipleOrgConfigurationSaga);
    yield takeLatest(ActionTypes.VM_MULTIPLE_ORG_UPSERT_REQUEST, UpsertVMMultipleOrgConfigurationSaga);
    yield takeLatest(ActionTypes.VM_MULTIPLE_ORG_DELETE_REQUEST, DeleteVMMultipleOrgConfigurationSaga);

    // VM Pre-Registration
    yield takeLatest(ActionTypes.VM_PRE_REGISTRATION_GET_REQUEST, GetVMPreRegistrationVisitorSaga);
    yield takeLatest(ActionTypes.VM_PRE_REGISTRATION_UPSERT_REQUEST, UpsertVMPreRegistrationVisitorSaga);
    yield takeLatest(ActionTypes.VM_PRE_REGISTRATION_DELETE_REQUEST, DeleteVMPreRegistrationVisitorSaga);

    // EAC User create
    yield takeLatest(ActionTypes.GET_EAC_USER_REQUEST, GetEACUser);
    yield takeLatest(ActionTypes.ADD_EAC_USER_REQUEST, AddEACUser);
     
    yield takeLatest(ActionTypes.UPDATE_EAC_USER_REQUEST, UpdateEACUsers);
}


